import { Component, Input, OnInit } from '@angular/core';
import { DataRefsByKey, MarketingFood, Unit } from '@shared/models/dataref.model';
import { RecipeLite } from '@shared/models/recipe/recipe-lite.model';
import { SimpleIngredientLite } from '@shared/models/ingredient/simple-ingredient-lite.model';
import { RefDataService } from '@services/ref-data.service';
import { FoodLite } from '@shared/models/food/food-lite.model';

interface IngredientDisplay {
  weight: { quantity: number };
  weightRatio: number;
  isMainIngredient: boolean;
  foodLabel?: string;
  unitLabel?: string;
  quantity?: number;
  absoluteOrder: number;
}

@Component({
  selector: 'app-semantization-block',
  templateUrl: './semantization-block.component.html',
  styleUrls: ['./semantization-block.component.scss'],
  standalone: false,
})
export class SemantizationBlockComponent implements OnInit {
  @Input() variant?: RecipeLite | null;
  @Input() marketingFoods: MarketingFood[] = [];
  @Input() yieldUnits?: DataRefsByKey<Unit> | null;
  @Input() domain = '';
  @Input() market = '';
  @Input() lang = '';
  unitList: Unit[] = [];
  ingredientList: IngredientDisplay[] = [];

  constructor(private refDataService: RefDataService) {}

  ngOnInit(): void {
    if (this.yieldUnits) {
      this.unitList = this.refDataService.translateReference(this.refDataService.toArray(this.yieldUnits), this.market, this.lang);
    }

    (this.variant?.detectedIngredients?.simpleIngredients ?? []).forEach((ingr: SimpleIngredientLite) => {
      const aggregatedIngredient = this.variant?.aggregatedIngredients?.find(
        (aggregatedIngredientVar) => aggregatedIngredientVar.food.key === ingr.food.key,
      );
      this.ingredientList.push({
        foodLabel: this.findFoodLabel(ingr.food),
        unitLabel: this.findUnitLabel(ingr.unit?.key),
        quantity: ingr.quantity,
        absoluteOrder: ingr.absoluteOrder,
        isMainIngredient: aggregatedIngredient ? aggregatedIngredient.isMainIngredient : false,
        weightRatio: ingr.weightRatio,
        weight: ingr.weight,
      });
    });
    this.ingredientList.sort((a, b) => a.absoluteOrder - b.absoluteOrder);
  }

  findUnitLabel(unitKey: string): string {
    const unit = this.unitList?.find((unitVar) => unitVar.key === unitKey);
    const abbreviation = unit?.abbreviation && unit?.abbreviation[this.market] ? unit?.abbreviation[this.market][this.lang] : null;
    return abbreviation ?? unit?.translatedName ?? '';
  }

  findFoodLabel(food: FoodLite): string {
    return food?.name.find((foodVar) => foodVar.lang === this.lang && foodVar.market === this.market)?.value ?? '';
  }
}
